import { Path, Svg } from "@react-pdf/renderer";

type PdfEntrepriseHeaderIconProps = {
  size?: number;
  style?: React.ComponentProps<typeof Svg>["style"];
};

export const PdfEntrepriseHeaderIcon = ({ size = 20, style }: PdfEntrepriseHeaderIconProps) => {
  return (
    <Svg width={size} height={(size * 20) / 15} viewBox="0 0 15 20" style={style}>
      <Path
        d="M0 18C0 19.1046 0.89543 20 2 20H5.05645V15.5507H9.94355V20H13C14.1046 20 15 19.1046 15 18V0H0V18ZM10.5242 2.22467H12.629V4.80176H10.5242V2.22467ZM10.5242 6.51982H12.629V9.09692H10.5242V6.51982ZM10.5242 10.815H12.629V13.3921H10.5242V10.815ZM6.45968 2.22467H8.56452V4.80176H6.45968V2.22467ZM6.45968 6.51982H8.56452V9.09692H6.45968V6.51982ZM6.45968 10.815H8.56452V13.3921H6.45968V10.815ZM2.39516 2.22467H4.5V4.80176H2.39516V2.22467ZM2.39516 6.51982H4.5V9.09692H2.39516V6.51982ZM2.39516 10.815H4.5V13.3921H2.39516V10.815Z"
        fill="#0A1A53"
      />
    </Svg>
  );
};
